const memoryValue = {};

const setValue = (key, value) => {
  localStorage.setItem(key, value);
  memoryValue[key] = value;
};

const getValue = (key) => {
  if (!memoryValue.hasOwnProperty(key)) {
    memoryValue[key] = localStorage.getItem(key);
  }
  return memoryValue[key];
};

const clearValue = (key) => {
  localStorage.removeItem(key);
  delete memoryValue[key];
}

export { setValue, getValue, clearValue };



// WEBPACK FOOTER //
// ./src/utils/keyStorage.js